import styled from "@emotion/styled";
import { COLOR_PRIMARY_MAIN, COLOR_WHITE } from "shared/theme/colors";
import { COLOR_GREY_5 } from "shared/theme/colors";

export const StyledFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  height: 40px;
  padding-bottom: 0.25rem;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${COLOR_GREY_5};
  box-sizing: content-box;
  background-color: ${COLOR_WHITE};
`;

export const StyledButton = styled.button`
  color: ${COLOR_PRIMARY_MAIN};
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  font-weight: 500;
  margin-left: 0.75rem;
  height: 2rem;

  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
    border-radius: 0.5rem;
  }
`;
